import { notificationEventTypes } from '@/views/Notification/NotificationBell/notificationt-types'

const state = () => ({
  isLoading: false,
  unreadNotifications: 0,
  recordsFiltered: 0,
  notifications: [],
  statuses: [
    {
      value: notificationEventTypes.CAMPAIGN_PAUSED_ACTIVATED,
      label: 'Campaign paused activated',
      color: 'primary'
    },
    {
      value: notificationEventTypes.CAMPAIGN_ACTIVATED,
      label: 'notification_bell.activated',
      color: 'primary'
    },
    {
      value: notificationEventTypes.CAMPAIGN_APPROVED,
      label: 'main.approval_statuses.approved',
      color: 'primary'
    },
    {
      value: notificationEventTypes.CAMPAIGN_REJECTED,
      label: 'main.approval_statuses.rejected',
      color: 'error text-white'
    },
    {
      value: notificationEventTypes.CAMPAIGN_LIMITS_BELOW_MIN,
      label: 'notification_bell.limits_below_minimal',
      color: 'warning text-white'
    },
    {
      value: notificationEventTypes.CAMPAIGN_FIRST_NEVER_PAID,
      label: 'notification_bell.first_never_paid',
      color: 'warning text-white'
    },
    {
      value: notificationEventTypes.CAMPAIGN_UNPROFITABLE_PAUSED,
      label: 'notification_bell.unprofitable_paused',
      color: 'warning text-white'
    },
    {
      value: notificationEventTypes.CAMPAIGN_LOW_PRICE,
      label: 'notification_bell.campaign_low_price',
      color: 'warning text-white'
    },
    {
      value: notificationEventTypes.AD_APPROVED,
      label: 'main.approval_statuses.approved',
      color: 'primary'
    },
    {
      value: notificationEventTypes.AD_REJECTED,
      label: 'main.approval_statuses.rejected',
      color: 'error text-white'
    },
    {
      value: notificationEventTypes.APPROVABLE_NEEDS_EDITS,
      label: 'main.approval_statuses.needs_edits',
      color: 'info'
    }
  ]
})

export default state
